import React, { Component, Fragment } from "react";

import NavbarItem from "./NavbarItem";

export default class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: false,
      icon: "bars"
    };
  }

  openSlideMenu = () => {
    this.setState({ menuIsOpen: true, icon: "x" });
  };

  closeSlideMenu = e => {
    this.setState({ menuIsOpen: false, icon: "bars" });
  };
  render() {
    return (
      <Fragment>
        <nav className="navbar">
          <div className="container">
            <span className="open-slide">
              {this.state.icon === "bars" ? (
                <a onClick={this.openSlideMenu}>
                  <i className="fas fa-bars side__menu-btn" />
                </a>
              ) : null}
            </span>
            <ul className="navbar__menu">
              <NavbarItem item="Home" link="home" />
              <NavbarItem item="About" link="about" />
              <NavbarItem item="Projects" link="projects" />
              <NavbarItem item="Contact" link="contact" />

              <li className="navbar__menu-item">
                <a
                  href="https://drive.google.com/file/d/1Z5QIv8iQNwT_sGOkMUoRQPuzgRlObJYR/view"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="navbar__menu-item-link resume"
                >
                  Resume
                </a>
              </li>
            </ul>
          </div>

          {this.state.menuIsOpen ? (
            <div className="side__menu" style={{ width: "100vw" }}>
              <a onClick={this.closeSlideMenu}>
                <i className="fas fa-times side__menu-btn" />
              </a>
              <div className="side__menu-content">
                <ul>
                  <NavbarItem
                    item="Home"
                    link="home"
                    closeMenu={this.closeSlideMenu}
                  />
                  <NavbarItem
                    item="About"
                    link="about"
                    closeMenu={this.closeSlideMenu}
                  />
                  <NavbarItem
                    item="Projects"
                    link="projects"
                    closeMenu={this.closeSlideMenu}
                  />
                  <NavbarItem
                    item="Contact"
                    link="contact"
                    closeMenu={this.closeSlideMenu}
                  />
                  <li className="navbar__menu-item">
                    <a
                      href="http://www.google.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="navbar__menu-item-link resume"
                    >
                      Resume
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <div className="side__menu" style={{ width: 0 }} />
          )}
        </nav>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js